/** Deliberate home action on unused xr-standard left thumbstick press (button 3).
 * Face buttons and thumbstick axes retain their existing meanings. */
export function createXRReturnHold(duration=1) {
  let elapsed=0,armed=true;
  return {
    reset(){elapsed=0;armed=false;},
    update(sources,dt,enabled=true){
      const pressed=enabled&&Array.from(sources??[]).some(source=>source.handedness==='left'&&source.gamepad?.mapping==='xr-standard'&&source.gamepad.buttons?.[3]?.pressed===true);
      if(!enabled){elapsed=0;armed=false;return {progress:0,trigger:false};}
      if(!pressed){elapsed=0;armed=true;return {progress:0,trigger:false};}
      if(!armed)return {progress:0,trigger:false};
      elapsed+=Number.isFinite(dt)?Math.max(0,Math.min(dt,.1)):0;
      const trigger=elapsed+1e-8>=duration,progress=Math.min(1,elapsed/duration);
      if(trigger){elapsed=0;armed=false;}
      return {progress,trigger};
    },
  };
}
